<div class="tire-report-form">
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="tireDateTime">Date/Time</label>
                <wj-input-date-time
                    [(ngModel)]="tireReport().dateTimeOfIssue"
                    name="tireDateTime"
                    id="tireDateTime"
                ></wj-input-date-time>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="tireJob">Job</label>
                <wj-combo-box
                    [(ngModel)]="tireReport().job"
                    (ngModelChange)="onJobChanged()"
                    name="tireJob"
                    id="tireJob"
                    [itemsSource]="jobOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
                @if (jobLocationHint) {
                    <small class="form-text text-muted">Job site: {{ jobLocationHint }}</small>
                }
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="tireOperator">Operator</label>
                <wj-combo-box
                    [(ngModel)]="tireReport().operatorName"
                    name="tireOperator"
                    id="tireOperator"
                    [itemsSource]="operatorOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isEditable]="false"
                ></wj-combo-box>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="tireEquipment">Equipment #</label>
                <wj-combo-box
                    [(ngModel)]="tireReport().equipmentId"
                    (ngModelChange)="onEquipmentChanged()"
                    name="tireEquipment"
                    id="tireEquipment"
                    [itemsSource]="equipmentOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isEditable]="false"
                ></wj-combo-box>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="tireEquipmentClass">Equipment class</label>
                <wj-combo-box
                    [(ngModel)]="tireReport().equipmentClass"
                    name="tireEquipmentClass"
                    id="tireEquipmentClass"
                    [itemsSource]="equipmentClassOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isEditable]="false"
                ></wj-combo-box>
                <small class="form-text text-muted">Filled from the equipment; change it if this is wrong.</small>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="tireProblemType">Problem type</label>
                <wj-combo-box
                    [(ngModel)]="tireReport().problemType"
                    name="tireProblemType"
                    id="tireProblemType"
                    [itemsSource]="problemTypeOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isEditable]="false"
                ></wj-combo-box>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="tireAxle">Axle # (facing forward)</label>
                <input
                    type="number"
                    class="form-control"
                    id="tireAxle"
                    name="tireAxle"
                    min="1"
                    [(ngModel)]="tireReport().axleNumber"
                    (ngModelChange)="onPositionChanged()"
                />
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="tireSide">Side (facing forward)</label>
                <wj-combo-box
                    [(ngModel)]="tireReport().side"
                    (ngModelChange)="onPositionChanged()"
                    name="tireSide"
                    id="tireSide"
                    [itemsSource]="sideOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isEditable]="false"
                ></wj-combo-box>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label>Resolved tire size</label>
                <div class="form-control-plaintext">{{ tireReport().resolvedTireSize || '—' }}</div>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="tirePhone">Your phone (so vendor can call)</label>
                <input
                    type="tel"
                    class="form-control"
                    id="tirePhone"
                    name="tirePhone"
                    [(ngModel)]="tireReport().submitterPhone"
                />
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label for="tireLocation">Current location / landmark</label>
                <input
                    type="text"
                    class="form-control"
                    id="tireLocation"
                    name="tireLocation"
                    [(ngModel)]="tireReport().locationDescription"
                    placeholder="Mile marker, intersection, or nearby landmark"
                />
                <div class="mt-2 d-flex flex-wrap align-items-center gap-2">
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="useMyLocation()" [disabled]="isLocating">
                        @if (isLocating) {
                            <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
                        } @else {
                            <fa-icon [icon]="faLocationCrosshairs"></fa-icon>
                        }
                        Use my location
                    </button>
                    @if (locationMapUrl()) {
                        <a [href]="locationMapUrl()" target="_blank" rel="noopener">Open map pin</a>
                        <button type="button" class="btn btn-link btn-sm p-0" (click)="clearCapturedLocation()">Clear pin</button>
                    }
                </div>
                @if (locationError) {
                    <small class="form-text text-danger">{{ locationError }} You can still save without a map pin.</small>
                }
            </div>
        </div>
    </div>

    @if (axleConfigPreview.length) {
        <div class="mb-3">
            <label class="form-label">Tire sizes on this machine</label>
            <ul class="mb-0 small">
                @for (row of axleConfigPreview; track row.axleNumber + row.side) {
                    <li>Axle {{ row.axleNumber }} {{ row.side }}: {{ row.tireSize }}</li>
                }
            </ul>
        </div>
    }

    <div class="form-group">
        <label for="tireNotes">Notes</label>
        <textarea class="form-control" id="tireNotes" name="tireNotes" rows="2" [(ngModel)]="tireReport().notes"></textarea>
    </div>

    <div class="form-group">
        <label>Damage photo</label>
        <div>
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="photoInput.click()">
                <fa-icon [icon]="faCamera"></fa-icon> Add photo
            </button>
            <input #photoInput type="file" accept="image/*" multiple hidden (change)="onPhotoSelected($event)" />
        </div>
        <div class="d-flex flex-wrap gap-2 mt-2">
            @for (img of tireReport().images; track $index) {
                <div class="position-relative">
                    <img [src]="img.url" alt="Damage" style="max-height: 80px; max-width: 120px" />
                    <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0" (click)="removePhoto($index)">
                        <fa-icon [icon]="faX"></fa-icon>
                    </button>
                </div>
            }
        </div>
    </div>

    @if (tireReport().id) {
        <div class="form-group">
            <label>Vendor receipt (accounting)</label>
            @if (tireReport().receiptImageUrls.length) {
                <ul class="small mb-2">
                    @for (url of tireReport().receiptImageUrls; track url) {
                        <li><a [href]="url" target="_blank" rel="noopener">Existing receipt</a></li>
                    }
                </ul>
            }
            <div>
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="receiptInput.click()">
                    Add receipt
                </button>
                <input #receiptInput type="file" accept="image/*,.pdf" multiple hidden (change)="onReceiptSelected($event)" />
            </div>
            <div class="d-flex flex-wrap gap-2 mt-2">
                @for (file of tireReport().receiptImages; track $index) {
                    <div class="position-relative border rounded p-1 small">
                        {{ file.name }}
                        <button type="button" class="btn btn-sm btn-danger ms-1" (click)="removeReceipt($index)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </button>
                    </div>
                }
            </div>
        </div>
    }
</div>
